import { React, useState } from "react";
import { Modal } from "../../context/Modal";
import Info from "./Index";

const InfoModal = ({post}) => {

    const [modal, setModal] = useState(false);

  return (
    <div>
    <button onClick={()=> setModal(true)} class="btn btn-danger">
        Info
    </button>
       { modal && (
        <Modal onClose={() => setModal(false)} >
            <Info post={post} setModal={setModal}/>
        </Modal>)  }
    </div>
  )
}

export default InfoModal

